import {IClaim} from '../models';
import {dateToApi} from '../../../util/helpers';
import {isUndefined} from 'util';

export function toJsonApi(claim: IClaim) {
  const data: any = {
    attributes: {
      claimed_at: dateToApi(claim.claimedAt),
      reference: '-',
      first_name: claim.firstName,
      last_name: claim.lastName,
      claim_type: claim.claimType,
      detail: !isUndefined(claim.detail) ? claim.detail : '-',
    },
    meta: {},
    relationships: {
      policy: {
        data: {
          id: claim.policy.id,
        },
      },
    },
  };

  return data;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/claim.ts